import './PillLabel.scss';

interface Props {
  label: string;
  isError?: boolean;
}

export const PillLabel = ({ label, isError = false }: Props) => {
  return <div className={`pill-label ${isError ? 'pill-label--error' : ''}`}>{label}</div>;
};
